// The four Rewards links, by a key that does not change with their labels ("Loyalty (Locked)").
// Set on the sidebar's Rewards items (hooks/useNavigationMenuItems.js) and read by the agent's
// Rewards quick start (components/AgentChat/RewardsStarter.js).
export const REWARD_KEYS = {
  LOYALTY: 'loyalty',
  COUPONS: 'coupons',
  GIFT_CARDS: 'gift_cards',
  WALLETS: 'wallets',
};
